export default __webpack_public_path__ + "static/media/placeholder_business06-jp-mobile.9f289f10.png";